import { UserPreview } from './user-preview';
import { HeadingName } from './heading-name';
import { useLocation, useRoute } from 'wouter';
import clsx from 'clsx';
import { useMachineStatus } from '../hooks/use-machine-status';
import { ResLoading } from './res-loading';

export const Header = () => {
  const [, setLocation] = useLocation();
  const [match] = useRoute('/orders|/historic-data|/issues|/settings');
  const { data: line, isLoading, error } = useMachineStatus();

  if (!line || isLoading) return <ResLoading />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="h-full flex items-center">
      <div
        className={clsx(
          'h-full px-8 my-4 w-1/4 cursor-pointer',
          match
            ? 'text-neutral-500 border-b-2 border-neutral-500 border-opacity-30'
            : 'bg-black text-white',
        )}
        onClick={() => setLocation('/')}>
        <div
          className={clsx(
            'h-full flex items-center justify-between border-neutral-500 border-opacity-30',
            match ? '' : 'border-b-2',
          )}>
          <span
            className="h-full w-44 flex items-center font-bold text-4xl bg-contain bg-no-repeat bg-center"
            style={{
              backgroundImage: match
                ? 'url(/leas-logo-gray.png)'
                : 'url(/leas-logo.png)',
            }}
          />
        </div>
      </div>
      <div
        className={clsx(
          'h-full w-3/4 px-8 flex items-center justify-between border-b-2 border-neutral-500 border-opacity-30',
          match && 'border-l-2',
        )}>
        <HeadingName
          name={line.workcenter_info.wc_name}
          status={line.current.status_code}
          started_at={line.current.state_start_unix_timestamp}
        />
        <UserPreview />
      </div>
    </div>
  );
};
